export default "__VITE_ASSET__BUZEw8CO__"